var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckboxField(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#595959"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13 .563L.562 1 1 13.438 13.438 13 13 .562z",
    transform: "translate(-153 -551) translate(121 540) translate(32 11)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.313 4l-4 5.125c-.113.137-.276.225-.45.238-.026.012-.038.012-.05.012-.163 0-.325-.063-.438-.188L4 6.813",
    transform: "translate(-153 -551) translate(121 540) translate(32 11)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxField);
export default __webpack_public_path__ + "static/media/checkbox-field.4a217cc6.svg";
export { ForwardRef as ReactComponent };